(() => {
  if (customElements.get('sn-mobile-gallery-arrows')) return;

  class SnMobileGalleryArrows extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.initialize());
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.events?.abort();
      this.resizeObserver?.disconnect();
      this.mutationObserver?.disconnect();
      this.events = null;
      this.frame = null;
    }

    initialize() {
      this.frame = null;
      if (!this.isConnected || this.events) return;
      this.host = this.parentElement;
      this.builder = this.closest('sn-cz-builder');
      this.track = this.builder ? this.host : this.host.querySelector('[data-product-slider-main-wrapper], .yv-product-gallery-items.yv-product-slider');
      if (!this.track) return;
      this.events = new AbortController();
      this.media = matchMedia(`(max-width: ${this.builder ? 760 : 767}px)`);
      const options = { signal: this.events.signal };
      this.addEventListener('click', (event) => this.step(event), options);
      this.media.addEventListener('change', () => this.schedule(), options);
      window.addEventListener('resize', () => this.schedule(), options);
      this.track.addEventListener('scroll', () => this.schedule(), { ...options, passive: true });
      this.track.addEventListener('load', () => this.schedule(), { ...options, capture: true });
      this.resizeObserver = new ResizeObserver(() => this.schedule());
      this.resizeObserver.observe(this.host);
      if (this.track !== this.host) this.resizeObserver.observe(this.track);
      this.mutationObserver = new MutationObserver(() => this.schedule());
      const observed = this.builder?.querySelector('[data-czb-thumbnails]') || this.track;
      this.mutationObserver.observe(observed, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'hidden', 'class', 'aria-pressed'] });
      this.update();
    }

    schedule() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        this.update();
      });
    }

    photos() {
      if (this.builder) return this.builder.set && typeof this.builder.images === 'function' ? this.builder.images() : [];
      return Array.from(this.track.children).filter((item) => item.matches('.yv-product-slider-item') && item.getClientRects().length);
    }

    current(photos, trackRect) {
      if (this.builder) return Number(this.builder.querySelector('[data-czb-photo][aria-pressed="true"]')?.dataset.czbPhoto || 0);
      const left = (trackRect || this.track.getBoundingClientRect()).left + this.track.clientLeft;
      let nearest = 0;
      let distance = Infinity;
      photos.forEach((item, index) => {
        const nextDistance = Math.abs(item.getBoundingClientRect().left - left);
        if (nextDistance < distance) {
          nearest = index;
          distance = nextDistance;
        }
      });
      return nearest;
    }

    update() {
      if (!this.isConnected) return;
      const photos = this.media.matches ? this.photos() : [];
      const track = photos.length >= 2 ? this.track.getBoundingClientRect() : null;
      if (!track?.width) {
        if (!this.hidden) this.hidden = true;
        return;
      }
      const selected = this.builder ? this.track.querySelector('img') : photos[this.current(photos, track)];
      const image = selected?.querySelector?.('.image-wrapper, .product-single__media') || selected || this.track;
      const host = this.host.getBoundingClientRect();
      const picture = image.getBoundingClientRect();
      // Measure before exposing or positioning the absolute overlay.
      const left = `${track.left - host.left - this.host.clientLeft}px`;
      const top = `${picture.top - host.top - this.host.clientTop + picture.height / 2 - 22}px`;
      const width = `${track.width}px`;
      if (this.hidden) this.hidden = false;
      if (this.style.left !== left) this.style.left = left;
      if (this.style.top !== top) this.style.top = top;
      if (this.style.width !== width) this.style.width = width;
    }

    step(event) {
      const button = event.target.closest('[data-gallery-step]');
      if (!button || !this.contains(button) || !this.media.matches) return;
      const photos = this.photos();
      if (photos.length < 2 || this.builder?.purchasing) return;
      const index = (this.current(photos) + Number(button.dataset.galleryStep) + photos.length) % photos.length;
      if (this.builder) this.builder.selectPhoto(photos[index]);
      else {
        const left = this.track.scrollLeft + photos[index].getBoundingClientRect().left - this.track.getBoundingClientRect().left - this.track.clientLeft;
        this.track.scrollTo({ left, behavior: 'instant' });
      }
      this.schedule();
    }
  }

  customElements.define('sn-mobile-gallery-arrows', SnMobileGalleryArrows);
})();
